/**
 * LogNode - Debug node that logs incoming events and displays them
 */

import { BaseNode } from '@nodes/BaseNode';
import { Domain } from '@nodes/Endpoint';
import { events, params } from '@nodes/TypedEndpoints';
import { Payload } from '@graph/Payload';
import { Dependencies } from '@nodes/Dependencies';
import type { NodeDef } from '@runtime/IRuntime';

const endpoints = {
  ...events({
    logs: { isInput: true, accepts:['any'],isOutput:true, allowInput: false, allowOutput: false, primary: true }
  }),
  ...params({
    logToConsole: { dataType: 'boolean', value: true }
  }
  )
};

export class LogNode extends BaseNode<typeof endpoints> {
  constructor(id: string, deps: Dependencies) {
    super(id, deps);
  }

  handleEvent(payload: Payload, endpointId: string): void {
    // Log to console if enabled
    if (this.params.logToConsole.value) {
      console.log(`[LogNode ${this.id}] event on '${endpointId}':`, JSON.stringify(payload, null, 2));
    }

    // Pass through
    this.events.logs.emit(payload);
  }
}

export const logNodeDef: NodeDef<LogNode> = {
  type: 'Log',
  shortName: 'log',
  info: 'Debug node that logs incoming events and displays their values.',
  domain: Domain.Data,
  endpoints,
  ctor: LogNode
};
